import { css, cx } from "@emotion/css";
import React from "react";
import type { PropsWithChildren } from "react";
export const popoverWidthOptions = ["narrow", "wide", "extra-wide"] as const;
export type PopoverWidth = (typeof popoverWidthOptions)[number];
export interface PopoverContentContainerProps {
    width?: PopoverWidth;
    boundaryPadding?: number;
}
export function PopoverContentContainer({ width, children, boundaryPadding = 24 }: PropsWithChildren<PopoverContentContainerProps>) {
    return (<div className={cx(popoverContentStyles, { [wideWidth]: width === "wide" }, { [extraWideWidth]: width === "extra-wide" })} style={{ padding: `${boundaryPadding}px` }}>
            {children}
        </div>);
}
const popoverContentStyles = css({
    maxWidth: "20.5rem",
});
const wideWidth = css({
    maxWidth: "25rem",
});
const extraWideWidth = css({
    maxWidth: "780px",
});
